/**
 * Monaco Editor Plugin (Client-side only)
 *
 * Configures the Monaco editor loader to use CDN resources.
 * The .client.ts suffix ensures this only runs in the browser.
 */
import { loader } from "@guolao/vue-monaco-editor";

export default defineNuxtPlugin({
  name: "monaco-editor",
  parallel: true,
  setup() {
    // Configure Monaco to load from CDN
    loader.config({
      paths: {
        vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.55.0/min/vs",
      },
    });
  },
});
